module.exports = __webpack_public_path__ + "img/biasBlack.5600260b.gif";